<ubs-ofbiz-form [ofbizForm]="findForm" [title]="title" [state] ="state"></ubs-ofbiz-form>

